module.exports = __webpack_public_path__ + "img/ca_zampa_animale_3.c4700cdc.jpg";